module.exports = __webpack_public_path__ + "static/media/cloud-upload.9f7736fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/cloud-upload.svg
// module id = 244
// module chunks = 0